module.exports = __webpack_public_path__ + "aff_logo.png?461a9c586d00c2af33ab49d1797fe456";